import { render, staticRenderFns } from "./ShareWishlist.vue?vue&type=template&id=49394a48&scoped=true"
import script from "./ShareWishlist.vue?vue&type=script&lang=js"
export * from "./ShareWishlist.vue?vue&type=script&lang=js"
import style0 from "./ShareWishlist.vue?vue&type=style&index=0&id=49394a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49394a48",
  null
  
)

export default component.exports